export default class IframeFullHeight {
    static $iframe = $('.js__set-iframe-full-height');
    static init() {
        if (!this.$iframe.length) {
            return;
        }
        this.$iframe.each((index, element) => {
            const $iframe = $(element);
            $iframe.on('load', e => {
                const $content = $iframe.contents();
                if (!$content.length) {
                    return;
                }
                const iframeHeight = $content.find('body').outerHeight() || 0;
                if (iframeHeight) {
                    $iframe.height(iframeHeight);
                }
            });
        });
    }
}
